// Wendet das Steuerberater-Branding (G7) auf das Klient-Portal an, indem es
// gezielt die Design-Tokens ueberschreibt. Ohne Werte bleibt die Standard-Optik
// aus `styles/tokens.css` — die Funktion ist additiv, nie destruktiv.

import type { KlientBranding } from "./session";

export function applyBranding(
  branding: KlientBranding | null | undefined
): void {
  const root = document.documentElement;
  // --bmd-navy = Haupttext/Headerfarbe, --bmd-green = Akzent/CTAs (tokens.css).
  if (branding?.primary_color) {
    root.style.setProperty("--bmd-navy", branding.primary_color);
  }
  if (branding?.accent_color) {
    root.style.setProperty("--bmd-green", branding.accent_color);
  }
}
